import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { ReturnFileBankSlipRequest } from '@/core/domain/financial/Boletos/Boletos.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Modal, ModalProps, Row, Upload } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { useEffect } from 'react';

export interface ReturnFileFormValues {
  companyId: number;
  file: { file: File; fileList: RcFile[] };
}

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  companyId?: number;
  onCallback: (values: ReturnFileBankSlipRequest) => void;
  loading?: boolean;
};

export default function BankSlipReturnFileModal({
  open,
  onCancel,
  companyId,
  onCallback,
  loading,
}: Props) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<ReturnFileFormValues>();

  const handleOk = async () => {
    const values = await form.validateFields();

    if (values.file.file) {
      const obj = { ...values, file: values.file.file };
      await onCallback(obj);

      form.resetFields();

      onCancel();
    }
  };

  useEffect(() => {
    if (companyId) {
      form.setFieldValue('companyId', companyId);
    }
  }, [open]);

  return (
    <Modal
      width={400}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      title="Leitura de arquivo de retorno"
      cancelText="Cancelar"
      okText="Enviar"
      okButtonProps={{ loading }}
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form.Item
              name="file"
              rules={[defaultEmptyFieldError]}
              style={{ margin: 0 }}
            >
              <Upload
                type="drag"
                name="file"
                maxCount={1}
                beforeUpload={() => {
                  return false;
                }}
              >
                Coloque seu arquivo aqui
              </Upload>
            </Form.Item>
          </Col>

          <Col span={24}>
            <FloatingFormItem label="Empresa" name="companyId">
              <CompaniesInfiniteSelectField disabled />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
